import { graphql } from 'app/generated/gql'

/**
 * The customer-facing read of a location's agent, on the public schema (AIAgentOverview), so
 * every workspace user with the practice can load it. Only fields a customer may see (TRK-6098
 * D4/D5): no prompt, addendum, tools, model, temperature, version, deploy date or voice.
 */
export const AI_AGENT_SETTINGS_CONFIG_QUERY = graphql(`
  query AiAgentSettingsConfig($locationId: ID!) {
    aiAgentConfiguration(locationId: $locationId) {
      id
      locationId
      agentName
      greeting
      businessName
      businessAddress
      postBookingMessage
      hygienePostBookingMessage
      smsConfirmationEnabled
      generalApptId
      emergencyApptId
      consultApptId
      limitedExamApptId
      offers {
        name
        patientStatus
        eligibleInsurance
        onlyEmergencyEligible
      }
      services {
        name
        lowPrice
        highPrice
        consultRequired
        consultPrice
      }
      servicesNotOffered {
        name
        lowPrice
        highPrice
        consultRequired
        consultPrice
      }
      sayThisNotThatRules {
        stopPhrase
        replacementPhrase
        channel
      }
    }
  }
`)

/** Chair names for the availability details, on the public schema so every workspace user sees them (TRK-6104). */
export const AI_AGENT_SETTINGS_OPERATORIES_QUERY = graphql(`
  query AiAgentSettingsOperatories($locationId: ID!) {
    operatories(locationId: $locationId) {
      id
      remote_id
      name
      display_name
    }
  }
`)

/**
 * The customer edit of a location's agent. Public, so any workspace user with the practice
 * can save; the API asks for the location settings permission before it changes a phone number.
 */
export const AI_AGENT_SETTINGS_UPDATE_MUTATION = graphql(`
  mutation AiAgentSettingsUpdate($locationId: ID!, $input: UpdateAIAgentLocationConfigInput!) {
    updateAIAgentLocationConfig(locationId: $locationId, input: $input) {
      id
      locationId
      agentName
      greeting
      businessName
      businessAddress
      sayThisNotThatRules {
        stopPhrase
        replacementPhrase
        channel
      }
    }
  }
`)

/**
 * Where the agent reads business hours from, derived from its compiler tools. Ops only, so it runs
 * for super users; everyone else sees the location's hours until the public read carries the
 * source (TRK-6108).
 */
export const AI_AGENT_SETTINGS_HOURS_SOURCE_QUERY = graphql(`
  query AiAgentSettingsHoursSource($locationId: ID!) {
    aiAgentConfigurations(locationId: $locationId) {
      id
      voiceAgentTools
    }
  }
`)

/** The voice agent's compiler tools; the business-hours source is one of them. Ops only. */
export const AI_AGENT_SETTINGS_COMPILER_TOOLS_MUTATION = graphql(`
  mutation AiAgentSettingsCompilerTools($locationId: ID!, $input: UpdateAIAgentCompilerConfigInput!) {
    opsUpdateAIAgentCompilerConfig(locationId: $locationId, input: $input) {
      id
      voiceAgentTools
    }
  }
`)
